import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Applications } from 'src/app/models/tv/tv';

interface App { val: boolean, type: string}

@Component({
  selector: 'app-apps-tv',
  templateUrl: './apps-tv.component.html',
  styleUrls: ['./apps-tv.component.scss']
})
export class AppsTvComponent implements OnInit {
  admin: boolean = localStorage.getItem('HechRomeoRole') == 'Manager' ? true : false;

  @Input() applications: Applications;
  @Output() applicationValueEmit = new EventEmitter<App>();

  constructor() { }

  ngOnInit(): void {
  }

  setApplication(val: boolean, type:string){
    this.applicationValueEmit.emit( {val: val, type: type} )
  }

}
